import { createContext } from 'react';
export const initialContext = {
    theme: '',
    darkMode: false,
    themeUpdateTS: 0,
};
const ThemeContext = createContext(initialContext);
export default ThemeContext;
